import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import React from 'react';
import type { ReactElement } from 'react';

import { Box, Text, ChevronRightIcon } from '@frontend/legacy-components';

type HelpModeResourceCardProps = HTMLChakraProps<'a'> & {
  isDisabled?: boolean;
  title: string;
  icon?: ReactElement;
  description: string;
  onClick?: () => void;
};

const HelpModeResourceCard = ({
  isDisabled,
  title,
  icon,
  description,
  onClick,
  ...rest
}: HelpModeResourceCardProps) => {
  const textColorProps = isDisabled ? { color: 'feature.secondary' } : {};
  const iconColorProps = isDisabled
    ? { color: 'interaction.disabled' }
    : { color: 'feature.secondary' };
  return (
    <Box
      border="1px solid"
      borderColor="separator.border"
      borderRadius="lg"
      display="flex"
      flexDirection="row"
      height={9}
      width="100%"
      pl={2}
      pr={2}
      bg={isDisabled ? 'interaction.surfaceDisabled' : 'page.surface'}
      transition="all 0.2s ease"
      cursor="pointer"
      onClick={isDisabled ? (e) => e.preventDefault() : onClick}
      _hover={isDisabled ? {} : { bg: 'interaction.surfaceHover' }}
      _active={isDisabled ? {} : { bg: 'interaction.surfaceActive' }}
      {...rest}
    >
      <Box margin="auto 0">
        {icon && React.cloneElement(icon, { size: 4, ...iconColorProps })}
      </Box>
      <Box flexGrow={1} margin="auto 0" ml={2}>
        <Text fontSize="lg" fontWeight="heavy" {...textColorProps}>
          {title}
        </Text>
        <Text {...textColorProps}>{description}</Text>
      </Box>
      <Box margin="auto 0">
        <ChevronRightIcon size={3} {...iconColorProps} />
      </Box>
    </Box>
  );
};

export default HelpModeResourceCard;
